import { render } from "./PoolUserStats.vue?vue&type=template&id=3deba19a&scoped=true&ts=true"
import script from "./PoolUserStats.vue?vue&type=script&lang=ts"
export * from "./PoolUserStats.vue?vue&type=script&lang=ts"

import "./PoolUserStats.vue?vue&type=style&index=0&id=3deba19a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3deba19a"]])

export default __exports__